import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { unarchiveArchivedFile } from '../../../../../../../stores/archived-files/archived-files.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getArchivedFile } from '../../../../../../../stores/archived-files/archived-files.selectors'

const mapStateToProps = (state, { id }) => {
  const file = getArchivedFile(state, id)
  return {
    id: file.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onUnarchive: () =>
    dispatch(unarchiveArchivedFile(ownProps.id)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ContextMenu)
